import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../helpers/export'
import BusinessOperatingStatusService from './service'

export const getBusinessOperatingStatusTable = createAsyncThunk(
  'companyAnalysis/industryOverview/businessStatus/getBusinessOperatingStatusTable',
  async (params, { rejectWithValue }) => {
    try {
      const res =
        await BusinessOperatingStatusService.getBusinessOperatingStatusTable(
          params,
        )

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const exportBusinessOperatingStatus = createAsyncThunk(
  'companyAnalysis/industryOverview/businessStatus/exportBusinessOperatingStatus',
  async (params) => {
    try {
      const res =
        await BusinessOperatingStatusService.exportBusinessOperatingStatus(
          params,
        )
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
